import { render, staticRenderFns } from "./Tim.vue?vue&type=template&id=13be3b48"
import script from "./Tim.vue?vue&type=script&lang=js"
export * from "./Tim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports